import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-update-overlay',
  imports: [MatProgressSpinnerModule, TranslateModule],
  templateUrl: './update-overlay.component.html',
  styles: `
    .overlay {
      position: fixed;
      inset: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      background: rgba(255,255,255,0.85);
      z-index: 9999;
    }
  `
})
export class UpdateOverlayComponent {}
